module.exports = __webpack_public_path__ + "media/images/sp/stores/kobe/kobe_sns_05-c4bb5a692ab01c442792304128f4f5cb.jpg";